window.RyftPayPaymentFormViewController = class RyftPayPaymentFormViewController
{
    /** @type {HTMLElement} */
    paymentWindow;
    /** @type {RyftPayParentFormViewController} */
    parentFormController;
    isSandbox = false;

    /** @type {HTMLElement} */
    paymentFormErrors;
    /** @type {HTMLInputElement} */
    payBtn;


    core = Minus40Core.getInstance();
    request = Minus40Request.getInstance();

    defaultError = "Unknown Ryft error [1]";
    /** @type {string[]} */
    lastErrors = [];

    paymentSessionId = "";
    cardDidValidate = false;
    payWasAttempted = false;
    cardError = "";
    billingAddressError = "";
    paymentDidFail = false;
    ajaxurl = "";
    ryft_pay_submission_nonce = "";
    useFakePayment = false;

    /**
     *
     * @param {{}} ryftPayInitParams
     * @param {string} paymentSessionId
     * @param {HTMLElement} paymentWindow
     * @param {RyftPayParentFormViewController} parentFormController
     * @param {string} embeddedJavascriptSRC
     * @param {string} ajaxurl
     * @param {string} pluginPath
     * @param {string} ryft_pay_submission_nonce
     * @param {boolean} isSandbox
     */
    constructor(ryftPayInitParams, paymentSessionId, paymentWindow, parentFormController, embeddedJavascriptSRC, ajaxurl, pluginPath, ryft_pay_submission_nonce, isSandbox)
    {
        this.paymentSessionId = paymentSessionId;
        this.parentFormController = parentFormController;
        this.isSandbox = isSandbox;

        this.paymentWindow = paymentWindow.querySelectorAll('.ryft-pay-payment-window')[0] ?? null;
        const paymentForm = this.paymentWindow.querySelectorAll('#ryft-pay-form')[0] ?? null;
        this.paymentFormErrors = paymentForm?.querySelectorAll('.ryft-errors')[0] ?? null

        this.payBtn = paymentForm?.querySelectorAll('#pay-btn')[0] ?? null;

        this.ajaxurl = ajaxurl;
        this.ryft_pay_submission_nonce = ryft_pay_submission_nonce;

        /** @type {HTMLInputElement} */
        const cancelBtn = paymentForm?.querySelectorAll('.cancel-ryft-btn')[0] ?? null;

        const valid = !!this.paymentSessionId && !!this.payBtn && !!cancelBtn && !!this.paymentFormErrors && !!embeddedJavascriptSRC && !!this.ajaxurl && !!this.ryft_pay_submission_nonce;

        if(!valid){
            this.submitCancel("Invalid Payment Form");
            return;
        }

        const imageFolder = pluginPath ? (pluginPath + "/assets/img") : null;
        const loadingElement = this.paymentWindow.querySelectorAll('.ryft-pay-payment-window-loading')[0] ?? null;
        const loadingImageElement = loadingElement?.querySelectorAll('.loading-image')[0] ?? null;
        if(imageFolder && loadingImageElement){
            const loadingImagePath = imageFolder + "/loading.gif"
            loadingImageElement.style.backgroundImage = "url('"+loadingImagePath+"')";
        }

        this.handleWalletPaymentSessionResult = this.handleWalletPaymentSessionResult.bind(this);
        this.handleCardValidationChanged = this.handleCardValidationChanged.bind(this);
        this.handleWalletButtonsReady = this.handleWalletButtonsReady.bind(this);
        this.handlePaymentMethodSelectionChanged = this.handlePaymentMethodSelectionChanged.bind(this);
        this.handleBillingAddressValidationChanged = this.handleBillingAddressValidationChanged.bind(this);
        this.onPaymentFormSubmit = this.onPaymentFormSubmit.bind(this);


        cancelBtn.onclick = () => {
            this.submitCancel()
        }

        this.paymentWindow.classList.add('initializing');
        this.payBtn.classList.add('disabled');

        this.core.embedJavascript(embeddedJavascriptSRC, (success) => {


            if (!success) {
                this.submitCancel("Could not load embedded RyftPay");
                return;
            }

            Ryft.init(ryftPayInitParams);

            Ryft.addEventHandler("walletPaymentSessionResult", this.handleWalletPaymentSessionResult);
            Ryft.addEventHandler("cardValidationChanged", this.handleCardValidationChanged);
            Ryft.addEventHandler("walletButtonsReady", this.handleWalletButtonsReady);
            Ryft.addEventHandler("paymentMethodSelectionChanged", this.handlePaymentMethodSelectionChanged);
            Ryft.addEventHandler("billingAddressValidationChanged", this.handleBillingAddressValidationChanged);

            paymentForm.addEventListener("submit", this.onPaymentFormSubmit);
            this.paymentWindow.classList.remove('initializing');
        })
    }

    /**
     *
     * @param {string|string[]=} messages
     */
    submitCancel(messages){

        const callSubmitError = () => {
            messages = messages ? (Array.isArray(messages) ? messages : [messages]) : [];
            messages = messages.length ? messages : this.lastErrors;
            this.parentFormController.submitCancel(messages);
        }


        this.paymentWindow.classList.add('processing');
        this.handlePaymentCancelled()
            .then(callSubmitError)
            .catch((error) => {
                if(!this.lastErrors.length){
                    this.lastErrors = this.normalizeErrors(error);
                }
                callSubmitError();
            })

    }

    submitSuccess(){
        this.parentFormController.submitSuccess();
    }

    async fakePaymentFormSubmit() {
        setTimeout(() => {
            this.handlePaymentResult({status: "Approved"}, true);
        }, 3000)
    }

    async onPaymentFormSubmit(e) {
        e.preventDefault();
        this.payWasAttempted = true;
        if(this.getValidationError()){
            this.handleInputValidation();
            return;
        }

        this.paymentWindow.classList.add('processing');
        this.removeErrors();
        if(this.useFakePayment){
            return this.fakePaymentFormSubmit();
        }

        Ryft.attemptPayment()
            .then((paymentSession) => {
                this.handlePaymentResult(paymentSession);
            })
            .catch((error) => {
                this.handleErrors(error);
            });
    }

    /**
     *
     * @param attemptNumber {number}
     * @param testSuccess {boolean=}
     * @returns {Promise<void>}
     * @throws {Minus40ApiError}
     */
    async validatePaymentResult(attemptNumber = 0, testSuccess) {
        attemptNumber ++;
        if(attemptNumber > 30){
            const apiError = new Minus40ApiError();
            apiError.code = "too_many_attempts";
            apiError.message = "We did not receive a valid response from Ryft.";
            throw apiError;
        }

        const submitValues = {
            action: "ryft_pay_validate_payment_result",
            paymentSessionId: this.paymentSessionId,
            nonce: this.ryft_pay_submission_nonce
        };

        return this.request.fetchData(this.ajaxurl, "POST", submitValues, null, "formdata").then(async (response) => {
            const status = response?.data.status ?? "pending";
            if(status === "pending"){
                await this.core.sleep(2000);
                return this.validatePaymentResult(attemptNumber, testSuccess);
            }
            return response;
        });
    }


    /**
     *
     * @returns {Promise<void>}
     * @throws {Minus40ApiError}
     */
    async handlePaymentCancelled() {

        const submitValues = {
            action: "ryft_pay_handle_payment_cancelled",
            paymentSessionId: this.paymentSessionId,
            nonce: this.ryft_pay_submission_nonce,
            paymentDidFail: this.paymentDidFail
        };

        return this.request.fetchData(this.ajaxurl, "POST", submitValues, null, "formdata").then( (response) => {
            return response;
        });
    }

    handlePaymentResult(paymentSession, test) {
        if (
            paymentSession.status === "Approved" ||
            paymentSession.status === "Captured"
        ) {
            this.paymentWindow.classList.add('processing');
            this.validatePaymentResult(0, test).then(async (response) => {
                this.submitSuccess()
            }).catch(
                /**
                 *
                 * @param {Minus40ApiError} error
                 */
                (error) => {
                    this.handleErrors(error)
                }
            )
            return;
        }
        this.paymentDidFail = true;
        const error = paymentSession.lastError ? Ryft.getUserFacingErrorMessage(paymentSession.lastError) : null;
        this.handleErrors(error ?? this.defaultError);
    }

    /**
     *
     * @param {any} error
     * @returns {string}
     */
    errorToString(error) {
        if((typeof error === 'object')) {
            error = error.message ?? error;
        }
        if(error){
            const obj = typeof error === 'string' ? this.core.validJSON(error) : (typeof error === 'object' ? error : null);
            if(obj){
                let objErrors = obj.errors ?? (obj.error ?? (obj.message ?? null));
                objErrors = objErrors ? (Array.isArray(objErrors) ? objErrors : [objErrors]) : [];
                for(let objError of objErrors) {
                    if((typeof objError === 'object')) {
                        const errorString = objError.message ?? (objError.error ?? (objError.code ?? null));
                        if(errorString){
                            return errorString;
                        }
                    } else if((typeof objError === 'string') && objError) {
                        return objError;
                    }
                }
            }
        }

        if ((typeof error === 'object') && !Object.keys(error).length) {
            error = error.toString()
        }
        if (!error || !this.core.isString(error)) {
            error = this.defaultError;
        }
        return error;
    }

    /**
     *
     * @param {any} error
     * @param {boolean=} isLocalError
     */
    handleErrors(error, isLocalError) {
        const errors = this.normalizeErrors(error);
        let innerHTML = "";
        for (let error of errors) {
            innerHTML += "<p>" + error + "</p>";
        }
        if(!isLocalError){
            this.lastErrors = errors;
        }

        this.paymentWindow.classList.remove('processing');
        this.paymentWindow.classList.add("has-errors");
        this.paymentFormErrors.innerHTML = innerHTML;
    }


    /**
     *
     * @param {any} error
     */
    normalizeErrors(error) {
        const errors = Array.isArray(error) ? error : [error];

        const normalizedErrors = [];
        for (let error of errors) {
            error = this.errorToString(error);
            normalizedErrors.push(error);
        }
        return normalizedErrors;
    }

    removeErrors() {
        this.paymentWindow.classList.remove("has-errors");
        this.paymentFormErrors.innerHTML = "";
    }

    handleWalletPaymentSessionResult(e) {
        this.handlePaymentResult(e.paymentSession);
    }

    handleCardValidationChanged(e) {
        this.payBtn.classList.remove('disabled');
        if(e.isValid){
            this.cardDidValidate = true;
            this.cardError = "";
        } else {
            if(e.cardNumberValid === false){
                this.cardError = "Please enter a valid credit card number";
            } else if(e.expirationValid === false){
                this.cardError = "Please enter a credit card expiry date";
            } else if(e.cvcValid === false){
                this.cardError = "Please enter a valid credit card CCV number";
            } else if(e.nameOnCardValid === false){
                this.cardError = "Please enter a credit card holder name";
            } else {
                this.cardError = "Invalid credit card";
            }
        }
        this.handleInputValidation();
    }

    handleBillingAddressValidationChanged(e) {
        if(e.isValid){
            this.billingAddressError = "";
        } else {
            this.billingAddressError = "Please enter a valid billing address";
        }
        this.handleInputValidation();
    }

    handleWalletButtonsReady(e) {
    }

    handlePaymentMethodSelectionChanged(e) {
    }

    handleInputValidation() {
        if(!this.payWasAttempted){
            return;
        }
        const validationError = this.getValidationError();
        if(!validationError){
            this.removeErrors();
        } else {
            this.handleErrors(validationError, true);
        }
    }

    getValidationError()
    {
        return this.cardError ? this.cardError : this.billingAddressError;
    }
}